import { subPageField } from '~/mixins/subpageType'

export const state = () => ({
  filterFields: {},
  grade: [],
  gender: [],
  ethnicity: [],
  reportTypes: [],
  filterHyperCube: {
    qInfo: { qType: 'visualization' },
    qHyperCubeDef: {
      qDimensions: [
        {
          qDef: {
            qFieldDefs: ['SchoolYear']
          },
          qNullSuppression: true
        },
        {
          qDef: {
            qFieldDefs: ['Grade']
          },
          qNullSuppression: true
        }
      ],
      qMeasures: [
        {
          qDef: {
            qLabel: 'Enrollment',
            qDef: '=Sum(Enrolled_Oct1)'
          }
        }
      ],
      qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
    }
  },
  filtersSelected: []
})

Array.prototype.sum = function(prop) {
  var total = 0
  for (var i = 0, _len = this.length; i < _len; i++) {
    total += this[i][prop]
  }
  return total
}

export const mutations = {
  setFilterValues(state, values) {
    state.filterValues = values
  },
  setGrades(state, grades) {
    state.grade = grades
  },
  setGenders(state, genders) {
    state.gender = genders
  },
  setEthnicities(state, ethnicities) {
    state.ethnicity = ethnicities
  },
  setSprReportTypes(state, reportTypes) {
    state.reportTypes = reportTypes
  },
  setFiltersSelected(state, val) {
    var index = state.filtersSelected
      .map(e => e.value.name)
      .indexOf(val.value.name) //makes new array of filter names then finds the index value of the selected filter
    if (index == -1) {
      state.filtersSelected.push(val) //if filters are not already selected, add to selected array
    } else {
      state.filtersSelected.splice(index, 1) //replace filters selected for field with new set of selected filters
    }
  },

  setPageType(state, data) {
    state.filterHyperCube.qHyperCubeDef.qDimensions.unshift(data)
  },

  addDimension(state, data) {
    state.filterHyperCube.qHyperCubeDef.qDimensions.push(data)
  },

  // Updating filters selected lists
  filterGrade(state, val) {
    if (state.filtersGrade.indexOf(val) == -1) {
      state.filtersGrade.push(val)
    } else {
      state.filtersGrade.splice(state.filtersGrade.indexOf(val), 1)
    }
  },
  filterGender(state, val) {
    if (state.filtersGender.indexOf(val) == -1) {
      state.filtersGender.push(val)
    } else {
      state.filtersGender.splice(state.filtersGender.indexOf(val), 1)
    }
  },
  filterEthnicity(state, val) {
    if (state.filtersEthnicity.indexOf(val) == -1) {
      state.filtersEthnicity.push(val)
    } else {
      state.filtersEthnicity.splice(state.filtersEthnicity.indexOf(val), 1)
    }
  },

  // Removing item from filters selected lists
  removeFilterGrade(state, val) {
    state.filtersGrade.splice(state.filtersGrade.indexOf(val), 1)
  },
  removeFilterGender(state, val) {
    state.filtersGender.splice(state.filtersGender.indexOf(val), 1)
  },
  removeFilterEthnicity(state, val) {
    state.filtersEthnicity.splice(state.filtersEthnicity.indexOf(val), 1)
  },

  // Clean all filters selected lists
  clearFilters(state) {
    state.filtersSelected = []
  }
}

export const getters = {
  grades: state => {
    return state.grade.filter(option => option.name != '-')
  },
  genders: state => {
    return state.gender.filter(option => option.name != '-')
  },
  ethnicities: state => {
    return state.ethnicity.filter(option => option.name != '-')
  },
  reportTypes: state => {
    return state.reportTypes.filter(option => option.name != '-')
  },
  filtersGrade: state => {
    return state.filtersGrade
  },
  filtersGender: state => {
    return state.filtersGender
  },
  filtersEthnicity: state => {
    return state.filtersEthnicity
  },

  filtersSelected: state => {
    return state.filtersSelected
  }
}

function filter(values, filterValue) {
  return values.filter((obj, pos, arr) => {
    return (
      arr.map(mapObj => mapObj[filterValue]).indexOf(obj[filterValue]) === pos
    )
  })
}

export const actions = {
  //get_filters is used to retreive the possible values for all of the fields that can be used in filter options. It also creates the initial set analysis for filter values used in charts.
  async get_filters({ commit }, payload) {
    const data = payload.data
    const pageTypeField = subPageField(data.type)
    const engine = await payload.engine

    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: [pageTypeField]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['SchoolYear']
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['Grade'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['Gender'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['Ethnicity'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['SPR.Report'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: false
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 6, qHeight: 1666 }]
      }
    }

    let overviewResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)
    let idx = 0
    if (pageTypeField !== 'citywide') {
      await overview.selectHyperCubeValues(
        '/qHyperCubeDef',
        0,
        [parseInt(data.slugid)],
        false
      )
    } else {
      idx -= 1
    }

    const layout = await overview.getLayout()

    const hcProps = {
      cols: {
        cols: layout.qHyperCube.qDimensionInfo.concat(
          layout.qHyperCube.qMeasureInfo
        )
      },
      width: layout.qHyperCube.qSize.qcx,
      height: Math.floor(10000 / layout.qHyperCube.qSize.qcx)
    }

    let fullMatrix = []
    let numReturnedrows = 0

    while (numReturnedrows < layout.qHyperCube.qSize.qcy) {
      const remData = layout.qHyperCube.qSize.qcy - numReturnedrows

      const fetchSize = remData < hcProps.height ? remData : hcProps.height

      let newData = await overview.getHyperCubeData({
        qPath: '/qHyperCubeDef',
        qPages: [
          {
            qLeft: 0,
            qTop: numReturnedrows,
            qWidth: hcProps.width,
            qHeight: fetchSize
          }
        ]
      })

      newData = newData[0].qMatrix

      numReturnedrows += newData.length

      fullMatrix = fullMatrix.concat(newData)
    }

    const values = fullMatrix

    for (let m = 0; m < values.length; m++) {
      const overviewData = {
        grade: values[m][2 + idx].qText,
        gradeId: parseInt(values[m][2 + idx].qElemNumber, 0),
        gender: values[m][3 + idx].qText,
        genderId: parseInt(values[m][3 + idx].qElemNumber, 0),
        ethnicity: values[m][4 + idx].qText,
        ethnicityId: parseInt(values[m][4 + idx].qElemNumber, 0),
        sprReport: values[m][5 + idx].qText,
        sprReportId: parseInt(values[m][5 + idx].qElemNumber, 0)
      }
      overviewResults.push(overviewData)
    }

    commit('setFilterValues', overviewResults)

    // Filtering filter values
    // Grades
    const grades = filter(overviewResults, 'gradeId').map(x => {
      return { id: x.gradeId, name: x.grade }
    })

    commit(
      'setGrades',
      grades.sort((a, b) => (a.name === 'K' ? -1 : a - b))
    )

    //Gender
    const genders = filter(overviewResults, 'genderId').map(x => {
      return { id: x.genderId, name: x.gender }
    })
    commit('setGenders', genders)

    //Ethnicity
    const ethnicities = filter(overviewResults, 'ethnicityId')
      .map(x => {
        return { id: x.ethnicityId, name: x.ethnicity }
      })
      .sort()
    commit('setEthnicities', ethnicities)

    const sprReportTypes = filter(overviewResults, 'sprReportId')
      .map(x => {
        return { id: x.sprReportId, name: x.sprReport }
      })
      .sort()
    commit('setSprReportTypes', sprReportTypes)

    const setAnalysis =
      ', [Grade]={' +
      grades.map(g => `'${g.name}'`) +
      '}, [Gender]={' +
      genders.map(g => `'${g.name}'`) +
      '}, [Ethnicity]={' +
      ethnicities.map(e => `'${e.name}'`) +
      '}'

    commit('subpage/selected/setFilterAnalysis', setAnalysis, { root: true })

    const sprSetAnalysis =
      ', [SPR.Report]={' + sprReportTypes.map(g => `'${g.name}'`) + '}'

    commit('subpage/selected/setSprFilterAnalysis', sprSetAnalysis, {
      root: true
    })
  }
}
